import React from 'react';
import SplitLayout from '../../common/layouts/splitLayout/SplitLayout';
import AvailableBalanceForm from './availableBalanceForm/AvailableBalanceForm';
import AvailableBalanceSummaryCard from './availableBalanceSummaryCard/AvailableBalanceSummaryCard';
import styles from './styles/available-balance-step.module.scss';

function AvailableBalanceStep({
    values,
    rules,
    options,
    enabled,
    handlers,
    summary,
    loading,
    disabledSave,
    submitText,
    confirmBeforeSubmit,
    onSubmit,
    onCancel,
    readOnly,
}) {
    return (
        <SplitLayout
            className={styles.splitRoot}
            contentClassName={styles.splitContent}
            sideClassName={styles.splitSide}
            side={<AvailableBalanceSummaryCard summary={summary} />}
        >
            <AvailableBalanceForm
                values={values}
                rules={rules}
                options={options}
                enabled={enabled}
                handlers={handlers}
                loading={loading}
                disabledSave={disabledSave}
                submitText={submitText}
                confirmBeforeSubmit={confirmBeforeSubmit}
                onCancel={onCancel}
                onSubmit={onSubmit}
                readOnly={readOnly}
            />
        </SplitLayout>
    );
}

export default AvailableBalanceStep;
